import { render, staticRenderFns } from "./TripsPage.vue?vue&type=template&id=d9868010&scoped=true&"
import script from "./TripsPage.vue?vue&type=script&lang=js&"
export * from "./TripsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9868010",
  null
  
)

export default component.exports